import React, { useCallback, useContext, useState } from "react";
import PageLayout from "../../component/pagelayout/PageLayout";
import "./LoginView.scss";
import Form from "@avinet/adaptive-ui-core/form/Form";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { listViewUrl, formUrl } from "../../constants/Routes";
import Input from "@avinet/adaptive-ui-core/form/controls/Input";
import { Link } from "react-router-dom";

interface LoginFormData {
  username: string;
  password: string;
}

const LoginView = () => {
  const test_username = "test";
  const test_password = "test";
  const navigate = useNavigate();

  const [showError, setShowError] = useState(false);
  const { isLoggedIn, handleLogin } = useContext(UserContext);

  const onSubmit = useCallback(
    (data: LoginFormData) => {
      if (isLoggedIn) {
        navigate(formUrl);
      }

      if (data.username === test_username && data.password === test_password) {
        setShowError(false);
        handleLogin(true);
        navigate(formUrl);
      } else {
        setShowError(true);
      }
    },
    [isLoggedIn, navigate, handleLogin]
  );

  return (
    <PageLayout>
      <div className="create-view">
        <div className="createform">
          <Form onSubmit={onSubmit}>
            <h4>Login</h4>
            <Input
              label={"Brukernavn"}
              id="username"
              type="text"
              placeholder="Skriv inn brukernavn..."
              required
            />
            <Input
              label={"Passord"}
              id="password"
              type="password"
              placeholder="Skriv inn passord..."
              required
            />
            {showError && <p className="error-msg">Feil brukernavn/passord</p>}
            <div className="buttons-wrapper">
              <Link to={listViewUrl} className="btn">
                Gå tilbake
              </Link>
              <button id="loginbtn" className="btn" type="submit">
                Login
              </button>
            </div>
          </Form>
        </div>
      </div>
    </PageLayout>
  );
};

export default LoginView;
